import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import {
  AdvancedCardSearch,
  FullProps,
} from '@sorare/marketplace/src/searchCards/AdvancedCardSearch';

import { PlayerDetails } from '@sorare/gameplay/src/components/player/PlayerDetails';

export const BaseballCardSearch = (
  props: Omit<
    FullProps,
    'sport' | 'CardResultsComponent' | 'PlayerDetailsComponent'
  >
) => (
  <AdvancedCardSearch
    sport={Sport.BASEBALL}
    PlayerDetailsComponent={PlayerDetails}
    {...props}
  />
);
